module.exports = function getResource(label) {
    const resources = { addPromo: 'Ajouter un code promotionnel' };
    return resources[label];
};
